import { useEffect } from 'react';
import { XUserInteraction } from '@core/utils';

const useCloseAttempt = (
  closeAttemptFired,
  denyCloseAttempt,
  setShowPopup,
  tlAskTxt,
  shouldSafeCancel
) => {
  useEffect(() => {
    if (
      closeAttemptFired.fired &&
      shouldSafeCancel &&
      !closeAttemptFired.supress
    ) {
      XUserInteraction.confirmDialog(
        tlAskTxt,
        () => setShowPopup(false),
        denyCloseAttempt
      );
    }
  }, [closeAttemptFired, shouldSafeCancel]);
};

export default useCloseAttempt;
